import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../firebase/config';
import { getClasificacionChip } from '../../../utils/styles';
import AlertaDeudaCliente from '../../alertas/AlertaDeudaCliente';


// Importamos las pestañas
import DatosContacto from './Tabs/DatosContacto';
import PolizasTab from './Tabs/PolizasTab'; 
import ContratosTab from './Tabs/ContratosTab'; 
// Nueva pestaña de Movimientos de Pago
import MovientosMedioPago from './Tabs/MovientosMedioPago';
// import TicketsTab from './Tabs/TicketsTab'; 

import ModalCliente from '../Clientes/ModalCliente';

const DetalleCliente = () => {
  const { id } = useParams(); 
  const navigate = useNavigate();
  
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('datos'); 
  
  const [showEditModal, setShowEditModal] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: '', isError: false });


  const fetchClient = async () => {
    try {
      const docRef = doc(db, 'public/data/clientes', id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setClient({ id: docSnap.id, ...docSnap.data() });
      } else {
        console.error("No se encontró el cliente");
      }
    } catch (error) {
      console.error("Error cargando cliente:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchClient();
  }, [id]);

  const handleEditSuccess = (msg, updatedClient) => {
    setClient(prev => ({ ...prev, ...updatedClient })); 
    setShowEditModal(false);
    showNotification(msg, false);
  };

  const showNotification = (msg, isError) => {
    setNotification({ show: true, message: msg, isError });
    setTimeout(() => setNotification({ show: false, message: '', isError: false }), 3000);
  };

  if (loading) {
    return (
        <div className="flex justify-center items-center h-screen bg-gray-50">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
    );
  }

  if (!client) {
    return (
        <div className="flex flex-col justify-center items-center h-screen bg-gray-50 text-gray-500">
            <p className="text-xl font-semibold">Cliente no encontrado</p>
            <button onClick={() => navigate('/clientes')} className="mt-4 text-blue-600 hover:underline">Volver a la lista</button>
        </div>
    );
  }

  /**
   * --- LÓGICA DE COEXISTENCIA DE DATOS (Email y Teléfono) ---
   * Buscamos el primer email válido en el array o caemos al campo plano legacy.
   * Esto asegura que los datos viejos se sigan viendo en el encabezado.
   */
  const primaryEmail = (Array.isArray(client.emails) && client.emails.find(e => e && e.trim() !== '')) 
                      || client.email 
                      || '';

  return (
    <div className="min-h-screen bg-gray-50 pb-10 text-left">
      
      {notification.show && (
         <div className={`fixed top-5 right-5 px-6 py-3 rounded-lg shadow-xl text-white font-medium z-50 transition-transform transform translate-y-0 ${notification.isError ? 'bg-red-600' : 'bg-green-600'}`}>
            {notification.message}
         </div>
      )}

      <header className="bg-white shadow-sm sticky top-0 z-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center text-left">
                <button onClick={() => navigate('/clientes')} className="mr-4 text-gray-400 hover:text-gray-600 transition-colors p-2 rounded-full hover:bg-gray-100" title="Volver">
                   <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
                </button>
                <div className="text-left">
                  <h1 className="text-2xl font-bold text-gray-900 leading-tight flex items-center gap-2 text-left">
                      {client.nombre} {client.apellido}
                      {client.clasificacion && (
                          <span className={`text-[10px] uppercase font-bold px-2 py-0.5 rounded-full ${getClasificacionChip(client.clasificacion)}`}>
                              {client.clasificacion}
                          </span>
                      )}
                      {/* Indicador inmediato si el cliente arrastra deuda */}
                      <AlertaDeudaCliente client={client} variant="badge" />                     
                  </h1>
                  <p className="text-sm text-gray-500 flex items-center mt-1 text-left">
                    <span className={`w-2 h-2 rounded-full mr-2 ${primaryEmail ? 'bg-green-400' : 'bg-gray-300'}`}></span>
                    {primaryEmail || 'Sin email principal'}
                  </p>
                </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-200 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <nav className="-mb-px flex space-x-8 overflow-x-auto text-left">
                    {['datos', 'polizas', 'contratos', 'pagos', 'tickets'].map((tab) => (
                        <button
                            key={tab}
                            onClick={() => setActiveTab(tab)}
                            className={`
                                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors
                                ${activeTab === tab 
                                    ? 'border-blue-600 text-blue-600' 
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
                            `}
                        >
                            {tab === 'datos' && 'DATOS DE CONTACTO'}
                            {tab === 'polizas' && 'PÓLIZAS'}
                            {tab === 'contratos' && 'CONTRATOS ART'}
                            {tab === 'pagos' && 'MOVIMIENTOS DE COBRO'}
                            {tab === 'tickets' && 'TICKETS ASOCIADOS'}
                        </button>
                    ))}
                </nav>
            </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 text-left">
        
        {activeTab === 'datos' && (
            <DatosContacto 
                client={client} 
                onEditClick={() => setShowEditModal(true)} 
            />
        )}

        {activeTab === 'polizas' && (
            <PolizasTab client={client} />
        )}

        {activeTab === 'contratos' && (
            <ContratosTab client={client} />
        )}

        {/* CONTENIDO DE LA NUEVA PESTAÑA */}
        {activeTab === 'pagos' && (
            <MovientosMedioPago client={client} />
        )}

        {activeTab === 'tickets' && (
            <div className="flex flex-col items-center justify-center p-12 bg-white rounded-lg border border-dashed border-gray-300 text-gray-400 text-center">
                <svg className="w-12 h-12 mb-4 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path></svg>
                <p>El módulo de Tickets estará disponible próximamente.</p>
            </div>
        )}

      </main>

      <ModalCliente
        show={showEditModal}
        client={client}
        onClose={() => setShowEditModal(false)}
        onSaveSuccess={handleEditSuccess}
        setNotification={(msg, isErr) => showNotification(msg, isErr)}
      />

    </div>
  );
};

export default DetalleCliente;